import { cn } from "@/lib/utils";
import { contentLabelsSelector } from "@/redux/loadedContent/loadedContentSlice";
import { getPlayerRoleByIdSelector } from "@/redux/players/playersSlice";
import { useSelector } from "react-redux";

type Props = {
  playerRoleId: number;
  focus: string;
  position: string;
  columns?: number;
};

export const PlayerRolePositionFocus = ({
  playerRoleId,
  focus,
  position,
  columns,
}: Props) => {
  const playerRole = useSelector(getPlayerRoleByIdSelector({ playerRoleId }));
  const { positions, focuses } = useSelector(contentLabelsSelector);
  const textWidth =
    columns < 4
      ? "w-[62px]"
      : columns === 4
        ? "w-[52px]"
        : " w-[40px] sb-v2-lg:w-[46px]";
  return (
    <div
      className={cn(
        "flex flex-col justify-center items-center px-0.5 py-0.5 text-xxs rounded text-center bg-panel-foreground",
        columns < 4 ? "w-[76px]" : "w-full",
      )}
    >
      <p className={cn("text-white whitespace-nowrap truncate", textWidth)}>
        {playerRole?.shortName}
      </p>
      <p className={cn("text-gray-300 whitespace-nowrap truncate", textWidth)}>
        {focuses[focus]?.name ?? focus}
      </p>
      <p className="text-secondary-dark">
        {positions[position]?.name ?? position}
      </p>
    </div>
  );
};
